import Car from "@/assets/icons/Car";
import ProtectedRoute from "@/components/layout/ProtectedRoute";
import Screen from "@/components/layout/Screen";
import AppButton from "@/components/shared/AppButton";
import { Card } from "@/components/shared/Card";
import PageTitle from "@/components/shared/PageTitle/PageTitle";
import VehicleList from "@/components/shared/VehicleList";
import { Skeleton, SkeletonText } from "@/components/ui/skeleton";
import { Text } from "@/components/ui/text";
import { useAccount } from "@/hooks/useAccount";
import { T, useT } from "@transifex/react";
import { useRouter } from "expo-router";

const MyVehicles = () => {
  const { account, isFetching, isLoading } = useAccount();
  const router = useRouter();
  const t = useT();

  const loading = isFetching || isLoading;

  return (
    <ProtectedRoute>
      <Screen>
        {loading ? <SkeletonText className="h-[24px] w-[220px] mx-auto" /> : <PageTitle title={t("Your Vehicles")} />}

        {(!account?.savedPlates || account?.savedPlates.length === 0) &&
          (loading ? (
            <Card className="pb-[24px] pt-[20px]">
              <Skeleton className="h-[22px] w-[180px] mx-auto mb-2" />
              <SkeletonText className="h-[40px] w-[250px] mx-auto" />
              <Skeleton className="h-[48px] w-[200px] mx-auto mt-4 rounded-lg" />
            </Card>
          ) : (
            <Card className="pb-[24px] pt-[20px]">
              <Text className="font-[700] leading-[22px] text-[16px] text-center text-typography-900">
                <T _str="Add a vehicle" />
              </Text>
              <Text className="font-[400] leading-[20px] text-[14px] text-center text-typography-900">
                <T _str="No vehicles saved in your account. Click below to add your first vehicle!" />
              </Text>
              <AppButton icon={Car} onPress={() => router.push("/my-vehicles/new-plate")} title={t("Add new vehicle")} />
            </Card>
          ))}
        {account?.savedPlates && account.savedPlates.length > 0 && <VehicleList vehicles={account.savedPlates} isLoading={loading} />}
      </Screen>
    </ProtectedRoute>
  );
};
export default MyVehicles;
